export default __webpack_public_path__ + "static/media/sound-muted.49eae846.svg";